// filepath: c:\Users\lakes\Documents\UNI\CO2104-CW2\frontend\src\utils\imageImports.js

/**
 * Utility function to handle image imports correctly in both development and production environments
 * This solves the common issue with Vite's asset handling in production builds, especially for
 * dynamic image imports that may not be correctly processed during build time.
 */

// Function to get image by path from assets directory
export function getImage(imagePath) {
  try {
    if (!imagePath) {
      console.error('No image path provided');
      return '';
    }

    // Clean up the path - remove /src/assets/ prefix if it exists
    let cleanPath = imagePath;
    if (imagePath.includes('/src/assets/')) {
      cleanPath = imagePath.split('/src/assets/')[1];
    } else if (imagePath.startsWith('/assets/')) {
      cleanPath = imagePath.split('/assets/')[1];
    }
    
    // Handle different path formats (with or without extension)
    const normalizedPath = !cleanPath.includes('.') 
      ? `${cleanPath}.jpg` 
      : cleanPath;
    
    // In production, Vite will handle the proper URL structure with hashes
    // We just need to ensure we're pointing to the correct assets path
    const imageUrl = new URL(`../assets/${normalizedPath}`, import.meta.url).href;
    return imageUrl;
  } catch (error) {
    console.error(`Failed to load image: ${imagePath}`, error);
    // Return a fallback image or empty string
    return '';
  }
}